import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../../../../hooks'
import {
  postMockApplicantMatchSuggestionAccept,
  postMockApplicantMatchSuggestionDismiss,
} from '../../../../../../RentalPortalApplicant'
import { useApplicantProfileContext } from '../../../../RentalPortalApplicantProfile.hooks'

export function useApplicantFitCheckSuggestion() {
  const { t } = useTranslation()

  const { handleAddErrorNotification } = useNotification()

  const { applicantId, handleEntityReload } = useApplicantProfileContext()

  const [submittingField, setSubmittingField] = useState(null)

  async function resolveSuggestion({ request, suggestion }) {
    setSubmittingField(suggestion.field)

    try {
      await request({
        applicantId,
        field: suggestion.field,
        value: suggestion.value,
      })

      await handleEntityReload()
    } catch {
      handleAddErrorNotification({
        textButtonValue: t('RentalPortal.ListingRetryBtnKey'),
        title: t('RentalPortal.MatchSuggestionErrorKey'),
        onClickTextButton: () => resolveSuggestion({ request, suggestion }),
      })
    }

    setSubmittingField(null)
  }

  function handleAcceptSuggestion(suggestion) {
    return resolveSuggestion({
      request: postMockApplicantMatchSuggestionAccept,
      suggestion,
    })
  }

  function handleDismissSuggestion(suggestion) {
    return resolveSuggestion({
      request: postMockApplicantMatchSuggestionDismiss,
      suggestion,
    })
  }

  return { handleAcceptSuggestion, handleDismissSuggestion, submittingField }
}
